import { useCallback } from 'react';
import { useQueryClient, QueryKey } from 'react-query';

interface UseRemoveQueryByKeyHook {
  removeQuery: (key: QueryKey) => void;
}

export const useRemoveQueryByKey = (): UseRemoveQueryByKeyHook => {
  const queryClient = useQueryClient();

  const removeQuery = useCallback(
    (key: QueryKey) => {
      const state = queryClient.getQueryState(key);
      if (state) {
        queryClient.removeQueries(key);
      }
    },
    [queryClient]
  );

  return { removeQuery };
};
